import { render, staticRenderFns } from "./SyncFacebookPageModals.vue?vue&type=template&id=eb5a1bc4&"
import script from "./SyncFacebookPageModals.vue?vue&type=script&lang=ts&"
export * from "./SyncFacebookPageModals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports